<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang" ></Header>
		<div class="layout m-newList">
			<div class="list_count no-padding-top">
				<div class="wow flipInX animated">
					<img class="list_img" :src="zidiyiData.news_center.files" />
				</div>
				<div class="list_info">
					<div class="info_tit wow bounceInUp animated">
						<div class="tit_left">
							<span>热点聚焦</span>
							<el-divider direction="vertical"></el-divider>
							<span class="text-uppercase">hot topic</span>
						</div>
					</div>
					<!-- 列表 -->
					<div class="liebiao_list wow bounceInUp animated">
						<div class="liebiao_info css3 wow bounceInUp animated" v-for="(item,index) in arcList"
							:key="item.id" @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)" >
							<div class="info_left col-xs-12 col-lg-3">
								<img class="css3" :src="item.image"  />
							</div>
							<div class="info_right col-xs-12 col-lg-9" >
								<span class="right_tit">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
								<span class="jieshao">{{lang=='CN' ?item.cn_digest:item.en_digest}}</span>
								<div class="right_down">
									<span>{{item.publishtime_text}}</span>
									<div class="right_down_div">
										<span class="commo_span">
										<img class="eye" src="@/assets/news/eye.svg" />
											<span>{{item.view}}</span>
										</span>
										<span class="commo_span">
										<img src="@/assets/news/comment.svg" />
											<span>{{item.comment_num}}</span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage4" background :page-size="per_page"
								layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'

	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'list',
		data() {
			return {
				index: 0,
				currentPage4: 1,
				parent_id: 10,
				id: '',
				list: [], //
				jx_index: 29,
				per_page: 9,
				page: 1,
				zidiyiData: {
					news_center: {
						files: ''
					}
				},
				arcList: [], //内容列表
				content: {}, //内容详情
				total: 0,
				company_id: 1, //公司ID
				banner: '',
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			this.addLocatPath()
			this.getZidiyiData() //自定义图片

			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {

			if (this.$route.query.parent_id) {
				this.parent_id = this.$route.query.parent_id
				let data = {
					parent_id: this.parent_id
				}


				this.$axios.get("/api/jx/channel_list", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						this.list = res.data.data
						if (res.data) {
							this.getArchivesList(res.data.data[0].id)
						}
					}
				}).catch(err => {});
				return
			}
			let data = {
				channel_id: '',
				per_page: this.per_page,
				page: this.page,
				flag: 'hot'
			}
			this.$axios.get("/api/jx/archives_list", {
				params: data
			}).then((res) => {
				if (res.data.code == 1) {
					this.arcList = res.data.data.data
					this.total = res.data.data.total
				}
			}).catch(err => {});

		},
		methods: {
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			addLocatPath() {
				let data = {
					directions: '热点聚焦',
					path: window.location.href
				}


				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {}).catch(err => {});
			},
			getChannelList() {
				let data = {
					parent_id: this.parent_id
				}
				this.$axios.get("/api/jx/channel_list", {
					params: data
				}).then((res) => {
					if (res.data.code == 1) {
						this.list = res.data.data
						console.log(this.list);
					}
				}).catch(err => {});
			},
			getArchivesList(id) {
				let data = {
					channel_id: id,
					per_page: this.per_page,
					page: this.page,
					flag:'hot'
				}

				this.$axios.get("/api/jx/archives_list", {
					params: data
				}).then((res) => {
					if (res.data.data.code == 1) {
						res.data.data.data.map(item => {
							item.en_cont = item.en_digest ? item.en_digest : this.filtersText(item
								.en_content)
							item.cn_cont = item.cn_digest ? item.cn_digest : this.filtersText(item
								.cn_content)
						})
						
						this.arcList = res.data.data.data
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},

			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page,
				}

				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data
				}).catch(err => {});
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.getArchivesList(this.jx_index)
				console.log(`当前页: ${val}`);
			}
		}
	}
</script>

<style scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	a {
		color: #42b983;
	}
	.col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.m-newList {
		background: #fff;
	}

	.m-newList .list_count {
		padding: 30px;
	}

	.m-newList .list_info {
		margin: 50px auto;
		max-width: 1400px;
	}

	.m-newList .list_count .list_img {
		width: 100%;
	}

	.m-newList .info_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.m-newList .info_tit .active {
		border: 2px solid #006170;
		box-shadow: 5px 7px 10px #cddadc;
		color: #000;
	}

	.m-newList .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.m-newList .tit_left span:last-child {
		font-size: 12px;
		color: #999;
	}

	.m-newList .tit_right {
		display: flex;
	}

	.m-newList .tit_right span {
		height: 50px;
		line-height: 50px;
		padding: 0 15px;
		text-align: center;
		color: #999;
		font-size: 14px;
		display: block;
		border: 1px solid #eee;
		margin-left: 20px;
	}

	.m-newList .hover_span {
		cursor: pointer;
	}

	.m-newList .liebiao_list {
		margin-top: 50px;
		margin-left: -30px;
	}

	.m-newList .liebiao_info {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		padding: 30px;
		border-bottom: 1px solid #f0f4f5;
		cursor: pointer;
	}

	.m-newList .liebiao_info:hover {
		background: #f0f4f5;
	}

	.m-newList .info_left {
		margin-right: 30px;
		overflow: hidden;
		position: relative;
		z-index: 5;
	}

	.m-newList .info_left img {
		width: 100%;
		height: 200px;
	}

	.m-newList .info_left img:hover {
		transform: scale(1.2)
	}

	.m-newList .info_right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		z-index: 5;
	}

	.m-newList .right_down {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #999;
	}

	.m-newList .commo_span {
		display: flex;
		align-items: center;
		margin-left: 50px;
	}

	.m-newList .commo_span img {
		width: 20px;
		margin-right: 5px;
	}

	.m-newList .commo_span .eye {}

	.m-newList .right_down_div {
		display: flex;
		align-items: center;
	}

	.m-newList .right_tit {
		font-size: 16px;
		font-weight: bold;
		color: #000;
	}

	.m-newList .right_tit:hover {
		color: #006170;
	}

	.m-newList .jieshao {
		font-size: 14px;
		color: #666666;
	}

	.m-newList .jieshao:hover {
		opacity: 0.8;
	}

	.m-newList .fenye {
		margin-top: 50px;
		text-align: center;
	}

	.m-newList .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}

	@media screen and (max-width: 1400px) {
		.m-newList .list_info {
			width: 100%;
		}
	}
</style>
